import { createSlice } from "@reduxjs/toolkit";

const registrationSlice = createSlice({
  name: "registration",
  initialState: {
    bookingDetails: null,
    activeStep: 0,
    steps: ["Booking details", "Review booking", "Booking Status"],
  },
  reducers: {
    setBookingDetails(state, action) {
      state.bookingDetails = action.payload;
      state.activeStep++;
    },
    setActiveStep(state, action) {
      state.activeStep = action.payload;
    },
    setDiscount(state, action) {
      state.bookingDetails = action.payload;
    }
  },
});

export const registrationActions = registrationSlice.actions;
export default registrationSlice;
